import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import useWhatsApp from '@/lib/useWhatsApp';

const message = "Hi Jotunheims! I'm interested in your services and would like more information.";

export default function WhatsAppFloatButton() {
  const { waLink, t } = useWhatsApp();
  return (
    <div className="fixed right-4 bottom-4 sm:right-5 sm:bottom-5 md:right-6 md:bottom-6 z-50">
      <motion.div
        animate={{
          boxShadow: [
            '0 0 6px 2px rgba(0, 229, 255, 0.08), 0 0 0px 0px rgba(255, 255, 255, 0)',
            '0 0 16px 6px rgba(0, 229, 255, 0.3), 0 0 6px 2px rgba(255, 255, 255, 0.08)',
            '0 0 24px 10px rgba(0, 229, 255, 0.22), 0 0 14px 6px rgba(255, 255, 255, 0.2)'
          ]
        }}
        transition={{ duration: 2.5, repeat: Infinity, repeatType: 'reverse', ease: 'easeInOut' }}
        className="absolute inset-0 rounded-full pointer-events-none"
      />
      <motion.a
        href={waLink(message)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('Chat on WhatsApp')}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        whileHover={{ scale: 1.1 }}
        transition={{ duration: 0.3 }}
        className="relative w-11 h-11 sm:w-12 sm:h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary/50 hover:bg-primary text-primary-foreground shadow-lg hover:shadow-primary/50 hover:shadow-2xl opacity-50 hover:opacity-100 transition-all duration-300"
      >
        <MessageCircle className="w-5 h-5 sm:w-5 sm:h-5 md:w-6 md:h-6" />
      </motion.a>
    </div>
  );
}